<div class="scroll-bar transparent">
  <div class="contact position-relative" (click)="selectUser(contact)" [ngClass]="{active: selectedUser?.id === contact.id, 'stickyStyle': fromSticky}"
    *ngFor="let contact of contacts$ | async; index as i">
    <div class="contact-remove-button" *ngIf="!fromSticky">
      <icon-button (onClick)="removeContact(contact)">
        <span class="iconfont iconguanbi"></span>
      </icon-button>
    </div>
    <div class="mr-4 avatar-container" *ngIf="!fromSticky">
      <img class="avatar-sm" [src]="contact.avatar +'?w=110&h=110&mode=crop'" />
      <!-- <div class="avatar-vip" *ngIf="contact.isOfficalSpeaker">
        <img style="width: 20px;" src="{{'./assets/images/officalSpeaker.png' |absUrl}}">
      </div>
      <div class="avatar-vip" *ngIf="contact.isOfficalUP && !contact.isOfficalSpeaker">
        <img style="width: 20px;" src="{{'./assets/images/officalUp.png?v=1' |absUrl}}">
      </div>
      <div class="avatar-vip" *ngIf="!contact.isOfficalUP && !contact.isOfficalSpeaker">
        <img style="width: 20px;" [src]="_resourceService.getBadge(getMembership(contact.gid))">
      </div> -->
      <app-membership-icon class="avatar-vip new-icon"
        [ngClass]="{'small': contact.isOfficalSpeaker || contact.isOfficalUP}"
        [membership]="contact.isOfficalSpeaker ? 'speaker' : contact.isOfficalUP ? 'bigV' : getMembership(contact.gid)"
        [noText]="true" [newIcon]="true">
      </app-membership-icon>
      <div class="has-new" *ngIf="contact.hasNew"></div>
    </div>
    <div class="overflow-hidden" *ngIf="!fromSticky">
      <div class="contact-name">{{ contact.name }}</div>
      <div class="text-secondary" *ngIf="!contact.lastMessageText && !!contact.lastMessage ">
        {{(contact.lastMessage)  * 1000 | date:'yyyy年MM月dd日 HH:mm'}}</div>
      <div class="text-secondary last-message" *ngIf="!!contact.lastMessageText" [innerHtml]="contact.lastMessageText">
      </div>
    </div>

    <div class="avatar-container mr-1 d-flex align-items-center justify-content-center stickyStyle" *ngIf="fromSticky">
      <img class="avatar-sm stickyStyle" [src]="contact.avatar + '?w=110&h=110&mode=crop'"/>
      <!-- <div class="avatar-vip-sticky" *ngIf="contact.isOfficalSpeaker">
        <img style="width: 10px;" src="{{'./assets/images/officalSpeaker.png'|absUrl}}">
      </div>
      <div class="avatar-vip-sticky" *ngIf="contact.isOfficalUP && !contact.isOfficalSpeaker">
        <img style="width: 10px;" src="{{'./assets/images/officalUp.png?v=1'|absUrl}}">
      </div>
      <div class="avatar-vip-sticky" *ngIf="!contact.isOfficalUP && !contact.isOfficalSpeaker">
        <img style="width: 10px;" [src]="_resourceService.getBadge(getMembership(contact.gid)) | absUrl">
      </div> -->
      <app-membership-icon class="avatar-vip-sticky new-icon"
        [ngClass]="{'small': contact.isOfficalSpeaker || contact.isOfficalUP}"
        [membership]="contact.isOfficalSpeaker ? 'speaker' : contact.isOfficalUP ? 'bigV' : getMembership(contact.gid)"
        [noText]="true" [newIcon]="true">
      </app-membership-icon>
    </div>
    <div class="overflow-hidden name stickyStyle" *ngIf="fromSticky">
      <div class="contact-name" style="max-width: 48px; font-size: 12px;">{{ contact.name }}</div>
    </div>
    <div class="has-new stickyStyle" *ngIf="fromSticky && contact.hasNew"></div>
    <div class="contact-remove-button stickyStyle" *ngIf="fromSticky">
      <icon-button (onClick)="removeContact(contact)">
        <span class="iconfont iconguanbi"></span>
      </icon-button>
    </div>
  </div>
</div>
